import { defineComponent as _defineComponent } from 'vue'
import { Trade } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import DrawdownCreator from '../DrawdownCreator.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawdownModal',
  props: {
    trade: null,
    buttonTitle: { default: 'Drawdown' }
  },
  setup(__props: any) {

const modal = ref<BModal | null>(null);



function show() {
  modal.value?.show();
}

function hide() {
  modal.value?.hide();
}

return { __sfc: true,modal, show, hide, BModal, DrawdownCreator }
}

})